import {
	LuIcon,
	Menu,
	type MenuClickTriggerProps,
	type MenuMultiSelectGroupProps,
	type MenuRootProps,
	type MenuVariantProps,
} from "@overmap-ai/blocks"
import { memo, type ReactElement } from "react"

import { PROJECT_TIMELINE_ITEM_TYPE_GROUPS } from "../../constants"
import { ProjectTimelineItemTypeGroup } from "../../enums/projects"
import { projectTimelineItemTypeGroupData } from "../../mappings/projects"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

interface ProjectTimelineItemTypeGroupMultiSelectDropdownProps
	extends
		MenuRootProps,
		MenuMultiSelectGroupProps<ProjectTimelineItemTypeGroup>,
		MenuVariantProps,
		Omit<MenuClickTriggerProps, "children" | "ref"> {
	children: ReactElement
}

export const ProjectTimelineItemTypeGroupMultiSelectDropdown =
	memo<ProjectTimelineItemTypeGroupMultiSelectDropdownProps>((props) => {
		const { children, disabled, variant, size, accentColor, values, onValuesChange, defaultValues, ...rest } = props

		return (
			<Menu.Root {...rest}>
				<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
				<Menu.Content variant={variant} size={size} accentColor={accentColor}>
					<Menu.Scroll>
						<Menu.MultiSelectGroup<ProjectTimelineItemTypeGroup>
							defaultValues={defaultValues}
							values={values}
							onValuesChange={onValuesChange}
						>
							<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
							{PROJECT_TIMELINE_ITEM_TYPE_GROUPS.map((type) => {
								const { icon, label } = projectTimelineItemTypeGroupData[type]

								return (
									<MultiSelectItemTemplate<ProjectTimelineItemTypeGroup> key={type} value={type}>
										<LuIcon icon={icon} />
										{label}
									</MultiSelectItemTemplate>
								)
							})}
						</Menu.MultiSelectGroup>
					</Menu.Scroll>
				</Menu.Content>
			</Menu.Root>
		)
	})
ProjectTimelineItemTypeGroupMultiSelectDropdown.displayName = "ProjectTimelineItemTypeGroupMultiSelectDropdown"
